<!--  -->
<template>
  <div>
    <el-form :label-position="labelPosition" label-width="60px" :model="formLabelAlign">
      <el-form-item label="主号">
        <el-tag v-if="formLabelAlign.app_id_a!=null" style="margin-right:10px">{{ name }}</el-tag>
        <el-button type="success" size="mini" @click="choosesimer">选择主号公众号</el-button>
      </el-form-item>
      <el-form-item label="副号">
        <el-tag
          v-for="itemr,index in arrs"
          :key="index"
          style="margin-right:10px;margin-bottom:5px"
          closable
          :type="itemr.type"
          @close="rightclick(itemr.id,index)"
        >
          {{ itemr.name }}
        </el-tag>
        <el-button type="success" :disabled="formLabelAlign.app_id_a==null" size="mini" @click="chooseaccountr">选择副号公众号</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="mini" @click="sumbit">确定</el-button>
      </el-form-item>
    </el-form>
    <el-dialog
      title="选择公众号"
      :visible.sync="dialogVisible"
      :modal-append-to-body="false"
      :append-to-body="true"
      width="35%"
    >
      <chooseaccount ref="simnre" @callback="callback" />
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="manydialogVisible"
      :modal-append-to-body="false"
      :append-to-body="true"
      width="50%"
    >
      <ChooseaccountDialog ref="chhoseaccout" @closedialog="closedialog" />
    </el-dialog>
  </div>
</template>

<script>
import chooseaccount from '../../correspondingAccount/components/chooseaccount.vue'
import ChooseaccountDialog from './chooseaccount.vue'
import { mainbindsub } from '@/api/sourceMaterial.js'
export default {
  components: { chooseaccount, ChooseaccountDialog },
  data() {
    return {
      labelPosition: 'right',
      dialogVisible: false,
      manydialogVisible: false,
      name: '',
      formLabelAlign: {
        app_id_a: null
      },
      arrs: [], // 选择公众号数组
      arrsw: []
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    choosesimer() {
      this.dialogVisible = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.simnre.sendrs(2)
      }, 100)
    },
    callback(val) {
      this.dialogVisible = false
      this.formLabelAlign.app_id_a = val.app_id
      this.name = val.account_name
      console.log('val', val)
    },
    chooseaccountr() {
      this.manydialogVisible = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.chhoseaccout.send(this.arrs, 4, this.formLabelAlign.app_id_a)
      }, 100)
    },
    rightclick(id, index) {
      this.arrs.splice(index, 1)
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.chhoseaccout.set(id)
      }, 100)
    },
    // 选择完 回调
    closedialog(arr) {
      this.arrs = arr
      this.manydialogVisible = false
      console.log('arr', arr)
    },
    async sumbit() {
      this.arrsw = []
      this.arrsw = this.arrs.map(item => {
        return item.id
      })
      const data = await mainbindsub({
        app_id_a: this.formLabelAlign.app_id_a,
        app_ids_b: this.arrsw
      })
      // const errorarr = []
      // eslint-disable-next-line eqeqeq
      if (data.data.fail.length == 0) {
        this.$message({
          type: 'success',
          message: `绑定成功`
        })
        this.$emit('updata')
      } else {
        // for (let i = 0; i < data.data.fail.length; i++) {
        //   errorarr.push(data.data.fail[i].account_name)
        // }
        // this.$message({
        //   type: 'error',
        //   message: `绑定失败的账号有:${errorarr}`
        // })
        this.$emit('updataerror', data.data.fail)
      }
      console.log('data', data)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
